import { connect } from "react-redux";
import { LocationCard as Component, LocationCardProps } from "./LocationCard.component";
import { RootState } from "../../../../reducers";
import { addGooglePlaceIdToDestination, updateDestinationWithPredictionAddress } from "../../../../action";
import { getTowToEnabled, getShowSponsoredLocation, getCurrentLocation } from "../../../../selector";

const mapStateToProps = (state: RootState) =>
  ({
    towToEnabled: getTowToEnabled(state),
    showSponsoredLocation: getShowSponsoredLocation(state),
    currentLocation: getCurrentLocation(state)
  } as Pick<LocationCardProps, "towToEnabled" | "showSponsoredLocation" | "currentLocation">);

export const LocationCard = connect(mapStateToProps, {
  handleNonTowToLocationClick: updateDestinationWithPredictionAddress,
  handleTowToLocationClick: addGooglePlaceIdToDestination,
} as Pick<LocationCardProps, "handleNonTowToLocationClick" | "handleTowToLocationClick">)(Component);
